import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateEasmScanConfigurationScheduler = document.createElement('template');

templateEasmScanConfigurationScheduler.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper">

      <gz-title fontSize="18" fontWeight="500" id="scheduler-title"/></gz-title>

      <div class='form-section'>
      <div class="container">
        <gz-text class="label" id="last-scan-date-label" fontSize="${FontSizes.HEADING_6}" fontWeight="${FontWeights.MEDIUM}"></gz-text>
        <gz-text class="value" id="last-scan-value" fontSize="${FontSizes.HEADING_6}" fontWeight="${FontWeights.MEDIUM}"></gz-text>
      </div>
        <div class="container">
        <gz-text class="label" id="next-scan-label" fontSize="${FontSizes.HEADING_6}" fontWeight="${FontWeights.MEDIUM}"></gz-text>
        <gz-text class="value" id="next-scan-value" fontSize="${FontSizes.HEADING_6}" fontWeight="${FontWeights.MEDIUM}"></gz-text>
      </div>
      <gz-form-field id='recurrence-form-field' class='label-mw-250' disabled="true" required>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
          <gz-input-error></gz-input-error>
      </gz-form-field>

      <div class="details-container">

        <div class="form-section" id="recurrence-weekly-container">
          <gz-form-field id='weekly-on-form-field' class='label-mw-250' required>
              <gz-multiselect-group gz-form-input></gz-multiselect-group>
              <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div id="common-fields-container">
              <div id="start-time-labeled-content">
                <div class="flex-group">
                  <gz-text fontSize="14" id="start-time-label"></gz-text> <!-- between -->
                  <gz-form-field id="start-time-form-field"  required>
                    <gz-time-picker gz-form-input></gz-time-picker>
                    <gz-input-error></gz-input-error>
                  </gz-form-field>
                </div>
              </div>
        </div>
      </div>
    </div>
    <br>
  </div>
`;
